import React, { useState, useImperativeHandle, forwardRef } from 'react'
import { Button } from '@material-ui/core'
import { useAuthDataContext } from '../../../../__providers/AuthProvider'
import Api from '../../../../__helpers/api'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Rating from '@material-ui/lab/Rating'
import { Link } from 'react-router-dom'

//images
import mainImage from '../../../../assets/images/modals/messages/feedback/main.png'
import thanksMainImage from '../../../../assets/images/modals/messages/feedback/thanks-main.png'
import loader from '../../../../assets/images/contacts/loader.svg'
import closeIcon from '../../../../assets/images/modals/messages/feedback/icons/close.png'
import feedbackIcon from '../../../../assets/images/modals/messages/feedback/icons/feedback.png'

//actions
import { refreshNotification } from '../../../../__actions/notifications'
import { handleModal } from '../../../../__actions/globalModals'

//dispatcher
import { useDispatch, useSelector } from 'react-redux'

function Feedback(props, ref) {
    const auth = useAuthDataContext()
    const dispatch = useDispatch()

    //
    const __data = useSelector(state => state)
    //
    const data = __data?.globalModalsReducer?.FEEDBACK?.data || {}

    const initialState = {
        step: 1,
        animationShow: 1,
        rating: 5,
    }

    const [state, setState] = useState({
        blur: false,
        popup: false,
        loading: false,
        validate: false,
        placeholder: '',
        ...initialState
    })

    useImperativeHandle(ref, () => ({
        open: () => handleOpen(),
        close: () => handleCloseMain()
    }))

    const handleOpen = () => {
        document.querySelector('body').style.overflow = 'hidden'
        document.querySelector('html').style.overflow = 'hidden'
        const placeholder = [
            'С Авто Обучение видях колко лесно може да се научи теорията.',
            'От приятели разбрах и ми е супер лесно и удобно да взема теорията през телефона.',
            'Сигурен съм, че няма да пропусна важен материал, защото минавам последователно през всички теми.'
        ]
        const random = Math.floor(Math.random() * placeholder.length - 1)
        setState(state => ({
            ...state,
            blur: true,
            placeholder: placeholder[random < 0 ? 1 : random]
        }))

        setTimeout(() => {
            setState(state => ({
                ...state,
                popup: true
            }))

        }, 50)
    }

    const handleCloseMain = () => {
        if (state.step == 2) {

            setStep(1)
            return
        }
        dispatch(handleModal('FEEDBACK', false, {}))

        document.querySelector('body').style.overflow = 'initial'
        document.querySelector('html').style.overflow = 'initial'

        Api.post('notifications/mark-as-read', {
            id: data?.id
        })
            .then(() => {
                dispatch(refreshNotification())
            })

        setState(state => ({
            ...state,
            popup: false
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                blur: false,
                ...initialState
            }))
        }, 100)
    }

    const handleGiveFeedback = () => setStep(2)

    const handleSendFeedback = () => {
        const checkbox = document.querySelector('.agree label[for="termsCheck"]')
        checkbox.style.borderBottom = 'none'

        if (document.getElementById('termsCheck').checked) {
            setState(state => ({
                ...state,
                loading: true,
                validate: false
            }))
            Api.post('reviews/add', {
                text: document.querySelector('textarea').value,
                rating: state.rating
            })
                .then(() => setStep(3))
                .catch(() => {
                    setState(state => ({
                        ...state,
                        validate: true
                    }))
                })
                .finally(() => {
                    setState(state => ({
                        ...state,
                        loading: false
                    }))
                })
        } else checkbox.style.borderBottom = '1px solid #ff5858'
    }

    const setStep = step => {
        setState(prev => ({
            ...prev,
            animationShow: step
        }))

        setTimeout(() => {
            setState(prev => ({
                ...prev,
                step
            }))

            const textarea = document.querySelector('textarea') || null
            if (textarea) {
                textarea.focus()
                textarea.value = ''
            }

        }, 200)
    }

    const handleChangeRating = (e, newValue) => {
        setState(prev => ({
            ...prev,
            rating: newValue
        }))
    }

    return (
        <div id="overlay" className={`scrollable-mobile ${state.blur ? 'visible' : ''}`}>
            {state.step == 1 ?
                <div className={`box feedback-modal ${state.animationShow == 1 ? 'show' : ''}`}>
                    <img src={closeIcon} className="close" onClick={handleCloseMain} />
                    <h2>
                        Помогни, като оставиш своя отзив
                    </h2>
                    <p>
                        {data?.name}, справяш се чудесно до тук и твоя отзив ще бъде полезен за други кандидат-шофьори. Заедно с теб можем да помогнем на други бъдещи шофьори да се справят по-добре и да бъдат толерантни на пътя.
                    </p>
                    <img src={mainImage} className="main" />
                    <div className="buttons">
                        <Button onClick={handleCloseMain} className="secondary">
                            Напиши <br />по-късно
                        </Button>
                        <Button onClick={handleGiveFeedback} className="primary">
                            <img src={feedbackIcon} />
                            Остави <br />своя отзив
                        </Button>
                    </div>
                </div>
                :
                state.step == 2 ?

                    <div className={`box feedback-modal ${state.animationShow == 2 ? 'show' : ''}`}>
                        <img src={closeIcon} className="close" onClick={handleCloseMain} />
                        <h2>
                            Сподели своето мнение и опит
                        </h2>
                        <p>
                            Нашата мисия е заедно с теб да сме полезни на бъдещите курсисти, за да направят
                            <br />
                            по-добрия избор.
                        </p>
                        <div className="field" onClick={() => document.querySelector('textarea').focus()}>
                            <picture>
                                <img src={auth.user.avatar} />
                            </picture>
                            <textarea placeholder={state.placeholder}></textarea>
                            {state.validate ?
                                <span className="validate">
                                    Моля, въведи отзив.
                                </span>
                                :
                                ''
                            }
                            <div className="rating">
                                <span>
                                    Оценка
                                </span>
                                <Rating
                                    name="simple-controlled"
                                    value={state.rating}
                                    onChange={handleChangeRating}
                                />
                            </div>
                        </div>
                        <h5>
                            {auth.user.name} {auth.user.lastname}
                        </h5>
                        <div className="agree">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="primary"
                                        id="termsCheck"
                                        name="terms"

                                    />
                                }
                            />
                            <label htmlFor="termsCheck" className="container">Съгласявам се, моят отзив и предоставените от мен лични данни да се използват от Авто Обучение съгласно условията посочени в <a href="/privacy" target="_blank">Политиката за защита на лични данни</a>.</label>
                        </div>
                        <div className="buttons">
                            {state.loading ?
                                <img src={loader} className="loader" alt="loading" />
                                :
                                <Button onClick={handleSendFeedback} className="primary single">
                                    Изпрати
                                </Button>
                            }
                        </div>
                    </div>
                    :
                    state.step == 3 ?
                        <div className={`box feedback-modal ${state.animationShow == 3 ? 'show' : ''}`}>
                            <img src={closeIcon} className="close" onClick={handleCloseMain} />
                            <img src={thanksMainImage} className="thanks-main" />
                            <h2 style={{ marginTop: '-10px' }}>
                                Благодарим ти, {data?.name}!
                            </h2>
                            <p style={{ marginBottom: '40px' }}>
                                Твоето мнение подобрява качеството на обучение и помага на други като теб
                                <br />
                                по пътя към успеха.
                            </p>
                            <div className="buttons">
                                <Button onClick={handleCloseMain} className="primary">
                                    Супер!
                                </Button>
                            </div>
                        </div>
                        :
                        ''
            }
        </div >
    )
}

export default forwardRef(Feedback)